<template>
  <b-modal
    :visible="isVisible"
    size="xl"
    hide-footer
    @hidden="closeModal"
  >
    <template #modal-title>
      {{ $t('yalnzQiymtMqayissiCdvli') }}
    </template>

    <!-- Loop through each company group -->
    <div
      v-for="(group, indexGroup) in groupedData"
      :key="group.company"
      class="mb-4"
    >
      <h4 class="mb-3">
        {{ group.company }} <span
          v-if="rankedOffers[indexGroup].rejected"
          class="text-danger"
        >Rədd edilib</span>
      </h4>
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>{{ $t('mhsullar') }}</th>
              <th class="text-center">
                Qiymət
              </th>
              <th class="text-center">
                {{ $t('request.dv') }}
              </th>
              <th class="text-center">
                Cəm
              </th>
              <th class="text-center">
                Global Sıra
              </th> <!-- New column for MAIN -->
              <th class="text-center">
                Alt Qiymət
              </th>
              <th class="text-center">
                {{ $t('request.dv') }}
              </th>
              <th class="text-center">
                Alt Cəm
              </th>
              <th class="text-center">
                Alt Global Sıra
              </th> <!-- New column for ALTERNATIVE -->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in group.products"
              :key="index"
            >
              <td>{{ item.product }}</td>
              <td class="text-center">
                {{ item.main.price ? item.main.price.toFixed(2) : '-' }}
              </td>
              <td class="text-center">
                {{ item.main.vat ? item.main.vat.toFixed(2) : '-' }}
              </td>
              <td class="text-center">
                {{ item.main.total ? item.main.total.toFixed(2) : '-' }}
              </td>
              <td class="text-center">
                <!-- We'll define a helper method getMainRank(indexGroup, item.product) below -->
                <span v-if="getMainRank(indexGroup, index)">
                  {{ getMainRank(indexGroup, index) }}-ci yer
                </span>
                <span v-else>-</span>
              </td>
              <td class="text-center">
                {{ item.alternative.price ? item.alternative.price.toFixed(2) : '-' }}
              </td>
              <td class="text-center">
                {{ item.alternative.vat ? item.alternative.vat.toFixed(2) : '-' }}
              </td>
              <td class="text-center">
                {{ item.alternative.total ? item.alternative.total.toFixed(2) : '-' }}
              </td>
              <!-- ALTERNATIVE Global Rank -->
              <td class="text-center">
                <span v-if="getAlternativeRank(indexGroup, index)">
                  {{ getAlternativeRank(indexGroup, index) }}-ci yer
                </span>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><strong>Ümumi </strong></td>
              <td
                colspan="3"
                class="text-center"
              >
                <span>Əsas cəm: {{ rankedOffers[indexGroup].mainTotal.toFixed(2) }} <span
                  :class="rankedOffers[indexGroup].mainRank===1? 'text-success' : 'text-muted' "
                >{{
                  rankedOffers[indexGroup].mainRank
                }}-ci yer </span></span>
              </td>
              <td
                colspan="3"
                class="text-center text-primary"
              >
                <span>Alternativ cəm: {{ rankedOffers[indexGroup].alternativeTotal.toFixed(2) }} <span
                  :class="rankedOffers[indexGroup].alternativeRank===1? 'text-success' : 'text-muted'"
                >{{
                  rankedOffers[indexGroup].alternativeRank
                }}-ci yer </span></span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- Export Buttons -->
    <div class="row pl-5 align-end mt-3">
      <b-button
        class="col-4 mr-5"
        @click="exportResultsOnlyPrice('xlsx')"
      >
        {{ $t('PQTOffersView.excelXar') }}
      </b-button>
      <b-button
        class="col-3"
        @click="exportResultsOnlyPrice('pdf')"
      >
        {{ $t('PQTOffersView.pdfXar') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "OnlyPriceComparisonModal",
  props: {
    visible: Boolean,
    onlyPriceComparisonData: Array,
    exportResultsOnlyPrice: Function,
    rankedOffers: Array
  },
  data() {
    return {
      isVisible: this.visible
    };
  },
  computed: {
    // Group the data by company (each company gets its own array of products)
    groupedData() {
      const groups = {};
      this.onlyPriceComparisonData.forEach(row => {
        // For each product row, loop through the companies available in this row
        Object.keys(row.companies || {}).forEach(company => {
          if (!groups[company]) {
            groups[company] = [];
          }
          groups[company].push({
            product: row["Məhsullar"],
            main: row.companies[company]?.main || {},
            alternative: row.companies[company]?.alternative || {}
          });
        });
      });
      return Object.keys(groups).map(company => ({
        company,
        products: groups[company]
      }));
    },
    // Calculate total main and alternative totals per company across all rows.
    // For alternative total, use alternative total if it exists, otherwise fallback to main total.
    companyTotals() {
      const totals = {};
      this.onlyPriceComparisonData.forEach(row => {
        Object.keys(row.companies || {}).forEach(company => {
          if (!totals[company]) {
            totals[company] = {mainTotal: 0, alternativeTotal: 0};
          }
          const mainTotal = row.companies[company]?.main?.total || 0;
          // Check if the alternative object exists and its total is defined.
          const alternativeTotal = (row.companies[company]?.alternative &&
              typeof row.companies[company]?.alternative.total !== 'undefined')
              ? row.companies[company].alternative.total
              : mainTotal;
          totals[company].mainTotal += mainTotal;
          totals[company].alternativeTotal += alternativeTotal;
        });
      });
      return totals;
    },
    hasAlternativeOverall() {
      return Object.values(this.companyTotals).some(t => t.alternativeTotal > 0);
    }
  },
  watch: {
    visible(newVal) {
      this.isVisible = newVal;
    },
    isVisible(newVal) {
      this.$emit("update:visible", newVal);
    }
  },
  methods: {
    getMainRank(indexGroup, productName) {
      // 1. Grab the correct "ranked offer" object
      const offer = this.rankedOffers[indexGroup];
      if (!offer || !offer.products) return null;

      // 2. Find the matching product by name (or ID)
      const matched = offer.products[productName]

      // 3. Return the global rank (for main price)
      return matched?.globalRank || null;
    },

    getAlternativeRank(indexGroup, productName) {
      const offer = this.rankedOffers[indexGroup];

      if (!offer || !offer.products) return null;

      const matched = offer.products[productName];
      // If there's an alternativeOffer, return its globalRank
      return matched?.alternativeOffer?.globalRank || null;
    },
    closeModal() {
      this.isVisible = false;
    },
    hasAlternative(row) {
      // Check if at least one company in this row has alternative data.
      return Object.values(row.companies).some(
          companyData => companyData?.alternative
      );
    }
  }
};
</script>

<style scoped>
.table-responsive {
  max-height: 70vh;
}

.text-primary {
  font-weight: 500;
}
</style>
